/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useMemo, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Scrollbars } from 'react-custom-scrollbars';
import { getUserApplicationRoutes } from '../authguard/routes';
import { useUserSelectedBranchLocation } from '../hooks/useUserSelectedBranchLocation';
import { SIDEBAR_ITEMS } from '../appContants';
import { useTour } from '@reactour/tour';

const SidebarMenuItem = ({ item, pathname }) => {
  const [expanded, setExpanded] = useState(
    pathname === item?.to ? true : false
  );

  return (
    <li className="submenu">
      <NavLink
        to={item?.to}
        id={item?.id}
        className={({ isActive }) => {
          const menuClass = `${item.id}-menu`;
          return isActive
            ? `${menuClass} active ${expanded ? 'subdrop' : ''}`
            : menuClass;
        }}
        onClick={() => setExpanded(!expanded)}
      >
        <span className="menu-side">
          <img src={item?.icon} alt={item?.title} />
        </span>{' '}
        <span>{item?.title} </span>{' '}
        {item?.children?.length ? <span className="menu-arrow" /> : null}
      </NavLink>
      <ul
        style={{ display: expanded ? 'block' : 'none' }}
        className={`${item?.id}-children`}
      >
        {item?.children?.length
          ? item?.children?.map((child) => {
              return (
                <li key={child?.id}>
                  <NavLink
                    className={({ isActive }) => {
                      return isActive ? 'active' : '';
                    }}
                    to={child?.to}
                  >
                    {child?.title}
                  </NavLink>
                </li>
              );
            })
          : null}
      </ul>
    </li>
  );
};

const Sidebar = (props) => {
  const { setIsOpen, setCurrentStep } = useTour();
  const { pathname } = useLocation();
  const { selectedLocation } = useUserSelectedBranchLocation();
  const userApplicationRoutes = useMemo(
    () => getUserApplicationRoutes(selectedLocation),
    [selectedLocation]
  );
  const userSidebarItem = useMemo(() => {
    const clone = structuredClone(SIDEBAR_ITEMS);

    return clone
      .map((item) => {
        if (item.children) {
          item.children = item.children.filter((child) =>
            userApplicationRoutes.includes(child?.to)
          );
        }
        return item;
      })
      .filter((item) =>
        item.children?.length
          ? true
          : userApplicationRoutes.includes(item?.to)
      );
  }, [userApplicationRoutes]);

  // useEffect(() => {
  //   if (props?.id && props?.id1) {
  //     const ele = document.getElementById(`${props?.id}`);
  //     handleClick(ele, props?.id, `${props?.id}-children`);
  //   }
  // }, []);

  const expandMenu = () => {
    document.body.classList.remove('expand-menu');
  };
  const expandMenuOpen = () => {
    document.body.classList.add('expand-menu');
  };
  return (
    <>
      <div className="sidebar" id="sidebar">
        <Scrollbars
          autoHide
          autoHideTimeout={1000}
          autoHideDuration={200}
          autoHeight
          autoHeightMin={0}
          autoHeightMax="95vh"
          thumbMinSize={30}
          universal={false}
          hideTracksWhenNotNeeded={true}
        >
          <div className="sidebar-inner slimscroll">
            <button
              className="btn btn-primary mb-3 ms-3"
              onClick={() => {
                setIsOpen(true);
                setCurrentStep(0);
              }}
            >
              Start Application Tour
            </button>
            <div
              id="sidebar-menu"
              className="sidebar-menu"
              onMouseLeave={expandMenu}
              onMouseOver={expandMenuOpen}
            >
              <ul>
                <li className="menu-title">Main Menu</li>
                {userSidebarItem?.map((item) => (
                  <SidebarMenuItem
                    key={item?.id}
                    item={item}
                    pathname={pathname}
                  />
                ))}
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
    </>
  );
};
export default Sidebar;
